import React from 'react';
import { Menu } from 'antd';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { menu } from './constants/menu';
import { links } from '../../../constants/links';
import useHousingStockMatch from '../../../hooks/useHousingStockMatch';
import styles from './MainNav.module.scss';

const { Item } = Menu;

const MainNav = ({ className, onLinkClick }) => {
  const match = useHousingStockMatch();

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const companyId = match?.params.companyId
    ? match.params.companyId
    : currentCompany?.id;

  return (
    <Menu
      className={cn(styles.root, className)}
      selectedKeys={[match?.params.page]}
      mode="horizontal"
    >
      {menu.map((item) => (
        <Item key={item.key}>
          <Link
            to={`${links.rootWithCompany}/${companyId}/${item.key}`}
            onClick={onLinkClick}
          >
            {item.content}
          </Link>
        </Item>
      ))}
    </Menu>
  );
};

export default MainNav;
